import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getAllOrders } from '../../../../../api/orderAPI';

export const useOrders = () => {
  const location = useLocation();
  const {
    data,
    isFetching,
    refetch: refetchOrders,
    isError,
    ...rest
  } = useQuery({
    queryKey: ['allOrders'],
    queryFn: getAllOrders,
    refetchOnWindowFocus: 'always',
  });

  useEffect(() => {
    if (location.state?.refetch) {
      refetchOrders();
    }
  }, [location.state, refetchOrders]);

  const allOrders = data?.orders || [];

  const onGoingOrders = allOrders.filter((order) =>
    [
        'active',
    ].includes(order.orderStatus)
  );

  const completedOrders = allOrders.filter(
    (order) =>
      ['completed'].includes(order.orderStatus) ||
      order.fullPaymentStatus === 'success'
  );

  const cancelledOrders = allOrders.filter(
    (order) =>
      ['cancelled'].includes(order.orderStatus) ||
      order.fullPaymentStatus === 'cancelled'
  );

  const pendingOrders = allOrders.filter(
    (order) =>
      ['pending', 'ongoing'].includes(order.orderStatus) 
      // order.paymentSummary.total_amount_paid !== 0
  );

  return {
    allOrders,
    onGoingOrders,
    completedOrders,
    cancelledOrders,
    pendingOrders,
    isFetching,
    refetchOrders,
    isError,
    ...rest,
  };
};
